// pages/CouleurMarque/couleurs/Couleurs.jsx
import React from 'react'
import { Card, Space, Tag, Progress, Tooltip } from 'antd'
import { 
    AlignLeftOutlined, 
    ShoppingCartOutlined, 
    DollarOutlined 
} from '@ant-design/icons';

const Couleurs = ({ data = [], loading = false }) => {
    // Couleurs de référence pour l'affichage
    const colorMap = {
        'Noir': '#1a1a1a',
        'Beige': '#f5e6d3',
        'Doré': '#d4af37',
        'Rouge': '#cc0000',
        'Léopard': '#b8860b',
        'Vert': '#2d8a4e',
        'Bleu': '#1a4d8a',
        'Marron': '#6b3a2a',
        'Blanc': '#f0f0f0',
        'Gris': '#808080',
        'Rose': '#e6a8b5',
        'Violet': '#6a1b6a'
    };

    // Couleurs max pour la progress bar
    const maxVentes = data.length > 0 ? Math.max(...data.map(item => item.quantite_vendue || 0)) : 0;

    const getColorStyle = (couleur) => {
        const color = colorMap[couleur] || '#666';
        return {
            backgroundColor: couleur.toLowerCase() === 'blanc' ? '#f5f5f5' : color,
            border: couleur.toLowerCase() === 'blanc' ? '1px solid #ddd' : 'none',
            color: ['Blanc', 'Beige', 'Doré'].includes(couleur) ? '#333' : '#fff'
        };
    };

    return (
        <Card className="marques" loading={loading}>
            <div className="marque_header">
                <Space>
                    <AlignLeftOutlined style={{ fontSize: 18, color: '#1a1a1a' }} />
                    <h3>Couleurs</h3>
                </Space>
                <Tag color="default">Top5 couleurs / ventes</Tag>
            </div>

            <div className="marque_list">
                {data.length === 0 ? (
                    <div className="empty-state">
                        <p>Aucune donnée disponible</p>
                    </div>
                ) : (
                    data.map((item, index) => {
                        const percent = maxVentes > 0 ? (item.quantite_vendue / maxVentes) * 100 : 0;
                        
                        return (
                            <div key={index} className="marque_item">
                                <div className="marque_info">
                                    <div className="marque_name_wrapper">
                                        <span 
                                            className="marque_color_dot" 
                                            style={getColorStyle(item.couleur)}
                                        />
                                        <span className="marque_name">{item.couleur}</span>
                                        <Tag 
                                            size="small" 
                                            color={item.recommandation?.includes('⭐') ? 'success' : item.recommandation?.includes('⚠️') ? 'error' : 'default'}
                                            className="marque_tag"
                                        >
                                            {item.recommandation?.includes('⭐') ? '⭐ Top' : item.recommandation?.includes('⚠️') ? '⚠️ Prudence' : 'Standard'}
                                        </Tag>
                                    </div>
                                    <div className="marque_stats">
                                        <Tooltip title="Quantité vendue">
                                            <span className="stat">
                                                <ShoppingCartOutlined /> {item.quantite_vendue || 0}
                                            </span>
                                        </Tooltip>
                                        <Tooltip title="Chiffre d'affaires">
                                            <span className="stat">
                                                <DollarOutlined /> {Number(item.chiffre_affaires || 0).toLocaleString()} $
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>
                                <Progress 
                                    percent={Math.round(percent)} 
                                    size="small" 
                                    status={percent > 50 ? "active" : "normal"}
                                    strokeColor={percent > 50 ? '#52c41a' : percent > 20 ? '#faad14' : '#ff4d4f'}
                                    showInfo={false}
                                />
                            </div>
                        );
                    })
                )}
            </div>
        </Card>
    )
}

export default Couleurs